import React, {useState} from 'react'
import {connect, useDispatch} from "react-redux";
import {selectItem, setGuiState} from "../../data/actions";
import {IoIosEye, IoIosEyeOff} from "react-icons/io";

const ModuleIcon = ({mod, gs}) => {
    const dispatch = useDispatch()

    const [over, setOver] = useState(false);

    function onClick() {
        dispatch(setGuiState({
            id: mod.id,
            show: !gs.show,
        }))
    }

    function onContext(e) {
        e.preventDefault()
        dispatch(selectItem(mod))
    }

    return (
        <div
            onMouseEnter={() => setOver(true)}
            onMouseOut={() => setOver(false)}

            style={{
                width: 'auto',
                overflow: 'auto',
                color: '#332f21',
                margin: 5,
                padding: 5,
                border: '1px solid #222222',
                background: gs.show ? '#c5bc99' : '#aba074',
                cursor: 'default',
                //fontWeight: over ? 'bold' : 'normal',
                opacity: over?0.8:1,
            }}
            onClick={onClick} onContextMenu={onContext}>
            {gs.show ? <IoIosEye/> : <IoIosEyeOff/>} {mod.prettyname || mod.id}
        </div>
    )
}

function mapStateToProps(state, other) {
    const itm = state.root.gui_state.find((itm) => {
        return itm.id === other.mod.id
    }) || {}
    return {gs: itm}
}

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ModuleIcon)
